import { render, staticRenderFns } from "./CreateGroupBtn.vue?vue&type=template&id=4437cc74&"
import script from "./CreateGroupBtn.vue?vue&type=script&lang=js&"
export * from "./CreateGroupBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports